import { useCallback, useEffect, useRef, useState } from 'react';
import { postApi } from '../lib/api';

let conversation = [];
let sessionId = crypto.randomUUID();
const createMessage = (role, content) => ({ ...content, role, id: crypto.randomUUID() });

export function useLeahConversation() {
  const [messages, setMessages] = useState(conversation);
  const [input, setInput] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const generation = useRef(0);
  const lock = useRef(false);
  useEffect(() => () => { generation.current++; }, []);

  const send = useCallback(async event => {
    event.preventDefault();
    const message = input.trim();
    if (!message || lock.current) return;
    const token = generation.current;
    const next = [...messages, createMessage('user', { message })];
    setMessages(next); conversation = next; setInput(''); setBusy(true); setError(''); lock.current = true;
    try {
      const response = await postApi('/chat', { message, sessionId });
      if (generation.current !== token) return;
      conversation = [...next, createMessage('assistant', response)];
      setMessages(conversation);
    } catch (failure) {
      if (generation.current !== token) return;
      setError(failure.message); setInput(message);
    } finally {
      if (generation.current === token) { setBusy(false); lock.current = false; }
    }
  }, [input, messages]);

  const reset = useCallback(() => {
    generation.current++; sessionId = crypto.randomUUID(); conversation = [];
    setMessages([]); setInput(''); setBusy(false); lock.current = false; setError('');
  }, []);
  return { messages, input, setInput, busy, error, send, reset };
}